import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { FaChevronLeft } from "react-icons/fa";
import Header from "../Header.js";
import useUser from "../../hook/useUser";


const Notification = () => {
    const navigate = useNavigate();
    const { user, loading } = useUser();

    const quizResult = user?.quizResult;
    const hasNotification = Boolean(quizResult?.updatedAt);

    const feedbacks = user?.feedbacks;
    const feedbackDate = feedbacks?.updatedAt || feedbacks?.createdAt;
    const hasFeedback = Boolean(feedbackDate);

    useEffect(() => {
        if (!user?.employeeId) return;

        const quizMs = quizResult?.updatedAt ? new Date(quizResult.updatedAt).getTime() : 0;
        const feedbackMs = feedbackDate ? new Date(feedbackDate).getTime() : 0;
        const latestMs = Math.max(quizMs, feedbackMs);

        if (!latestMs) return;

        const storageKey = `notification:lastSeen:${user.employeeId}`;
        localStorage.setItem(storageKey, String(latestMs));
    }, [user, quizResult, feedbackDate]);

    const formatDate = (dateString) => {
        if (!dateString) return "";
        return new Date(dateString).toLocaleString();
    };

    return (
        <>
        <div className="dashboard-inner">
            <Header />

            {/* dashboardに戻る */}
            <div onClick={() => navigate('/dashboard')} style={{ cursor: "pointer" }} className="nav_title">
                <FaChevronLeft className="fa-chevron-left"/>
                    Dashboard
            </div>
            <div className="notification-inner">
                <h2>Notification</h2>

                {loading && <p className="notification-empty">Loading...</p>}

                {!loading && hasNotification && (
                    <div className="notification-box">
                        <p className="notification-main">
                            <strong>Score updated:</strong> Your score for {quizResult.quizTitle} has been updated
                        </p>
                        <p className="notification-date">{formatDate(quizResult.updatedAt)}</p>
                    </div>
                )}

                {!loading && hasFeedback && (
                    <div className="notification-box">
                        <p className="notification-main">
                            <strong>Feedback updated:</strong> Your manager has updated feedback for {feedbacks.quizTitle}
                        </p>
                        <p className="notification-date">{formatDate(feedbackDate)}</p>
                    </div>
                )}

                {!loading && !hasNotification && !hasFeedback && (
                    <p className="notification-empty">No notifications yet.</p>
                )}

            </div>



        </div>
        </>
    )
}

export default Notification;